import { render } from "./ContentWithPhoto.vue?vue&type=template&id=595962a3"
import script from "./ContentWithPhoto.vue?vue&type=script&lang=js"
export * from "./ContentWithPhoto.vue?vue&type=script&lang=js"

import "./ContentWithPhoto.vue?vue&type=style&index=0&id=595962a3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__